const Header = () => {
    return (
        <div className="header">
            Travel Buddy
        </div>
    )
}

export default Header